import PropTypes from 'prop-types';
import InspirationSlider from '../InspirationSlider';
import WeddingCircleInPre from '../WeddingCircleInPre';
import EventTabs from './EventTabs';
import SimpleExtravagant from './SimpleExtravagant';
import GoFetch from '~/js/modules/fetchling';

const inspItemsFetch = new GoFetch();

export default class CollectionPanel extends React.Component {
  static propTypes = {
    inspirationURLParameter: PropTypes.number,
    inspirations: PropTypes.array,
    inspirationItems: PropTypes.array,
    inspirationEvents: PropTypes.array,
    countries: PropTypes.array,
    isMobile: PropTypes.bool,
    isAuthenticated: PropTypes.bool
  };

  static defaultProps = {
    inspirationURLParameter: null,
    inspirations: [],
    inspirationItems: [],
    inspirationEvents: [],
    countries: [],
    isMobile: false,
    isAuthenticated: false
  };

  constructor(props) {
    super(props);
    this.state = {
      currentInspiration: {},
      inspirationItems: [],
      displayingExtravagant: false
    };
  }

  componentWillMount() {
    const { inspirationURLParameter, inspirations } = this.props;

    if (inspirationURLParameter) {
      const currentInspiration = this._queryOnInspiration(inspirationURLParameter, inspirations);

      this.setState({ currentInspiration });
    }
  }

  componentDidMount() {
    $('.loader').hide();
    this._fetchInspirationItems();
  }

  _fetchInspirationItems = () => {
    const requestBody = {
      inspirationId: `${this.props.inspirationURLParameter}`
    };

    inspItemsFetch.post('/inspiration/items/', null, requestBody)
      .then((resp) => {
        const { data = {} } = resp;
        const { inspirationItems = [] } = data;

        this.setState({ inspirationItems });
      })
      .then(() => $('.sk-loader-ceremonyTab').hide())
      .catch((err) => console.error(err));
  };

  _queryOnInspiration = (inspirationURLParameter, inspirations = []) => {
    return inspirations.find(inspiration => inspiration.id === inspirationURLParameter) || {};
  };

  _extravagantSlider = () => this.setState({ displayingExtravagant: !this.state.displayingExtravagant });

  render() {
    const { currentInspiration = {} } = this.state;
    const collectionImages = currentInspiration.images || [];
    const receptionImages = collectionImages.collectionReception;
    const ceremonyImages = collectionImages.collectionCeremony;
    const simpleExtravagantImgs = collectionImages.simpleToExtravagant || [];

    const currentDesc = currentInspiration.description.replace('center', 'centre');

    return (
      <section>
        <InspirationSlider
          currentInspiration={currentInspiration}
          receptionImages={receptionImages}
          ceremonyImages={ceremonyImages}
          hasDots
        />
        <div className="container">
          <div className="row inspiration-intro">
            <div className="xs-12">
              <a href="/weddings/ideas/" className="back-btn show"><i className="icon-arrow-right" />back to inspirations</a>
              <h1 className="">{currentInspiration.name}</h1>
              <span className="inspiration-label">INSPIRATION</span>
              <div className="st-mini-div" />
            </div>
            <p className="xs-12 lg-8 desc-copy">{currentDesc}</p>
            <div className="xs-12 lg-4">
              <WeddingCircleInPre />
            </div>
          </div>
          {(simpleExtravagantImgs.length > 0)
            ? (<div className="xs-12 lg-6 xl-5 xxl-4 simple-extravagant-intro container-fluid">
              <p>Create Your Own</p>
              <div className="from-simple"><strong>from </strong><span>Simple to Extravagant</span></div>
              <label htmlFor="simpleExt" onClick={this._extravagantSlider} className={`btn-default ${(this.state.displayingExtravagant) ? 'active' : ''}`}>View How</label>
            </div>)
            : null
          }
        </div>
        {(simpleExtravagantImgs.length > 0)
          ? <SimpleExtravagant inspirationID={currentInspiration.id} inspirationName={currentInspiration.name} inspirationSimpleExtravagantImgs={simpleExtravagantImgs} updateExtravagantSlider={this._extravagantSlider} />
          : null
        }
        <EventTabs
          inspirationItems={this.state.inspirationItems}
          isMobile={this.props.isMobile}
          countries={this.props.countries}
          // catalogData = { catalogData }
          isAuthenticated={this.props.isAuthenticated}
          inspirationEvents={this.props.inspirationEvents}
          inspirationURLParameter={this.props.inspirationURLParameter}
          fetchInspirationItems={this._fetchInspirationItems}
        />
      </section>
    );
  }
}
